import React from "react";
import { observer } from "mobx-react";
import "./SharedCopyNotice.css";

/**
 * PLEX-6491 (Tim, 2026-10-09): a conversation shared with the user is read-only for them;
 * the first reply saves the user's own copy and continues there (LLMClient._forkFirst).
 * The URL change alone doesn't say that, so this notice does, while the loaded
 * conversation is someone else's. It goes away once the copy exists, and comes back if
 * saving the copy failed (_forkFirst restores _forkSourceId).
 */
const SharedCopyNotice = ({ client, className = "" }) => {
  if (!client?._forkSourceId) return null;
  return (
    <div className={`shared-copy-notice${className ? ` ${className}` : ""}`}
         role="status" data-testid="shared-copy-notice">
      Shared with you: replying makes your own copy.
    </div>
  );
};

export default observer(SharedCopyNotice);
